module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main situation videoSituation"
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "leftContent"
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeNamesFirst),
      callback: function($$v) {
        _vm.activeNamesFirst = $$v
      },
      expression: "activeNamesFirst"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.relationVideosTitle,
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "buttonZone"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.videoPlayStatus = !_vm.videoPlayStatus
      }
    }
  }, [_vm._v("全部播放/暂停")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.muted = !_vm.muted
      }
    }
  }, [_vm._v("全部静音/取消")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "videoUl"
  }, _vm._l((_vm.relationVideos), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('video', {
      staticClass: "myVideo",
      attrs: {
        "src": item,
        "type": "video/mp4",
        "controls": "controls",
        "width": "320",
        "height": "240",
        "preload": "",
        "loop": ""
      },
      domProps: {
        "muted": _vm.muted
      }
    })])
  }), 0)])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesSecond),
      callback: function($$v) {
        _vm.activeNamesSecond = $$v
      },
      expression: "activeNamesSecond"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.customerVideosTitle,
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "buttonZone"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cuVideoPlayStatus = !_vm.cuVideoPlayStatus
      }
    }
  }, [_vm._v("全部播放/暂停")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.cuMuted = !_vm.cuMuted
      }
    }
  }, [_vm._v("全部静音/取消")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "videoUl"
  }, _vm._l((_vm.customerVideos), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('video', {
      staticClass: "cuMyVideo",
      attrs: {
        "src": item,
        "type": "video/mp4",
        "controls": "controls",
        "preload": "",
        "loop": ""
      },
      domProps: {
        "muted": _vm.cuMuted
      }
    })])
  }), 0)])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesSecond),
      callback: function($$v) {
        _vm.activeNamesSecond = $$v
      },
      expression: "activeNamesSecond"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.directorVideosTitle,
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "buttonZone"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.diVideoPlayStatus = !_vm.diVideoPlayStatus
      }
    }
  }, [_vm._v("全部播放/暂停")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.diMuted = !_vm.diMuted
      }
    }
  }, [_vm._v("全部静音/取消")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "videoUl"
  }, _vm._l((_vm.directorVideos), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('video', {
      staticClass: "diMyVideo",
      attrs: {
        "src": item,
        "type": "video/mp4",
        "controls": "controls",
        "preload": "",
        "loop": ""
      },
      domProps: {
        "muted": _vm.diMuted
      }
    })])
  }), 0)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottomBtns"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40681e88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/components/videos.vue
// module id = v9uG
// module chunks = 6